var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-4"},[_c('h1',[_vm._v("会員登録用のメールを送信しました")]),_c('span',{staticStyle:{"color":"red","font-size":"1.8em","font-weight":"bold"}},[_vm._v(" 迷惑メールに入ってしまう可能性がございますので、5分以内に届かなかった場合は、チャットからお問い合わせくださいませ。"),_c('br')])])
}]

export { render, staticRenderFns }